import React, { useEffect, useState } from 'react';

// Extend the Window interface to include closeEnquiryModal
declare global {
    interface Window {
        closeEnquiryModal?: () => void;
    }
}

import FormOnly, { EnquiryFormContainerProps } from './EnquiryForm';
import OneClicks from './OneClicks';
import { IUserEnquiryData } from './types';
import { Modal } from 'react-bootstrap';

interface EnquiryFormWithOneClicksProps extends EnquiryFormContainerProps {
    inModal: boolean;
    isWordPress: boolean;
    postEnquiryUrl?: string;
}

const EnquiryFormWithOneClicks = ({ inModal, isWordPress, postEnquiryUrl, ...props }: EnquiryFormWithOneClicksProps) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showOneClicks, setShowOneClicks] = useState<boolean>(false);
    const [userEnquiryData, setUserEnquiryData] = useState<IUserEnquiryData | undefined>();
    
    const onCompleted = (userName: string, userEmail: string, userPhone: string, weddingDate: Date) => {
        setUserEnquiryData({ name: userName, email: userEmail, phone: userPhone, weddingDate });
        setShowOneClicks(true);
    };

    const closeModal = () => {
        setShowOneClicks(false);
    };

    const closeWpModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        if (isWordPress) {
            setShowModal(true);
        }
    }, []);

    const showPostEnquiryModal = async () => {
        if (!postEnquiryUrl) return;

        try {
            const response = await fetch(postEnquiryUrl);
            if (response.ok) {
                const htmlContent = await response.text();
                const enquirySentElements = document.getElementsByClassName('oneclicks-content');

                if (enquirySentElements.length === 0) {
                    const enquiryMobileElement = document.getElementById('ewmobileEnquiry');

                    if (enquiryMobileElement) {
                        enquiryMobileElement.innerHTML = htmlContent;
                    }

                    return;
                }

                for (let i = 0; i < enquirySentElements.length; i++) {
                    enquirySentElements[i].innerHTML = htmlContent;
                }
            } else {
                console.error('Failed to fetch HTML content:', response.status);
            }
        } catch (error) {
            console.error('Error fetching HTML content:', error);
        }
    }

    const inModalComponent = (inModal && !isWordPress) ? ((showOneClicks && !!userEnquiryData) ?
        <OneClicks
            categoryId={props.categoryId}
            supplierId={props.supplierId}
            regionId={props.supplierRegionId}
            supplierName={props.supplierName}
            userName={userEnquiryData.name}
            userEmail={userEnquiryData.email}
            userPhone={userEnquiryData.phone}
            weddingDate={userEnquiryData.weddingDate}
            onCompleted={() => {
                if (!!postEnquiryUrl) {
                    showPostEnquiryModal();
                }
                else if (inModal && typeof window.closeEnquiryModal === "function") {
                    window.closeEnquiryModal();
                }
            }}
        /> :
        <FormOnly {...props} onCompleted={onCompleted} />) : null;

    const inlineComponent = (!inModal && !isWordPress) ? (
        <>
            {(showOneClicks && !!userEnquiryData) &&
            <Modal show centered onHide={closeModal} size={'xl'} backdrop>
                {showOneClicks && <button type="button" className="btn-close" onClick={closeModal} aria-label="Close" style={{right: '1rem', top: '1rem', zIndex: 1, position: 'absolute'}}></button>}
                <Modal.Body className="oneclicks-content">
                    <OneClicks
                        categoryId={props.categoryId}
                        supplierId={props.supplierId}
                        regionId={props.supplierRegionId}
                        supplierName={props.supplierName}
                        userName={userEnquiryData.name}
                        userEmail={userEnquiryData.email}
                        userPhone={userEnquiryData.phone}
                        weddingDate={userEnquiryData.weddingDate}
                        onCompleted={() => {
                            if (!!postEnquiryUrl) {
                                showPostEnquiryModal();
                            }
                            else {
                                closeModal();
                            }
                        }}
                    />
                </Modal.Body>
            </Modal>}
            <FormOnly {...props} onCompleted={onCompleted} />
        </>        
    ) : null;

    const wpComponent = (isWordPress && showModal) ? (
        <Modal show centered onHide={closeWpModal} size={'xl'} backdrop={showOneClicks ? true : 'static'}>
            <Modal.Header closeButton className="pb-0 pt-4 border-0">
                <Modal.Title className="heading-sm mb-2 w-100 text-center"></Modal.Title>
            </Modal.Header>
            <Modal.Body className="oneclicks-content pt-md-4">
                {(showOneClicks && !!userEnquiryData) && <OneClicks
                    categoryId={props.categoryId}
                    supplierId={props.supplierId}
                    regionId={props.supplierRegionId}
                    supplierName={props.supplierName}
                    userName={userEnquiryData.name}
                    userEmail={userEnquiryData.email}
                    userPhone={userEnquiryData.phone}
                    weddingDate={userEnquiryData.weddingDate}
                    onCompleted={closeWpModal}
                />}
                {!showOneClicks && <FormOnly {...props} onCompleted={onCompleted} />}
            </Modal.Body>
        </Modal>
    ) : null;

    return (
        <>
            {inModalComponent}
            {inlineComponent}
            {wpComponent}
        </>
    );
};

export default EnquiryFormWithOneClicks;
